import { render, staticRenderFns } from "./ParamEstadoCivilForm.vue?vue&type=template&id=ca1fa634"
import script from "./ParamEstadoCivilForm.vue?vue&type=script&lang=js"
export * from "./ParamEstadoCivilForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports